import { Component, h } from '@stencil/core';

@Component({
  tag: 'ci-apparel',
  styleUrl: '../ci-apparel/ci-apparel.scss',
  shadow: true,
})
export class ciApparel {
  render() {
    const click_section = "apparel";
    return (
      <div class="ciProducts ciProducts--noPadding">
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/sweatshirts/hoodies/71`} data-section={click_section} data-link="Hoodies">Hoodies</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/sweatshirts/crewneck-sweatshirts/120`} data-section={click_section} data-link="Crewneck Sweatshirts">Crewneck Sweatshirts</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/sweatshirts/quarter-zip-sweatshirts/224`} data-section={click_section} data-link="Quarter Zip Sweatshirts">Quarter Zip Sweatshirts</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/sweatshirts/13`} data-section={click_section} data-link="View All Sweatshirts">View All Sweatshirts</a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/hats/baseball-hats/3`} data-section={click_section} data-link="Baseball Hats">Baseball Hats</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/hats/trucker-hats/201`} data-section={click_section} data-link="Trucker Hats">Trucker Hats</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/hats/beanies/39`} data-section={click_section} data-link="Beanies">Beanies</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/hats/1`} data-section={click_section} data-link="View All Hats">View All Hats</a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/jackets/14`} data-section={click_section} data-link="Jackets">Jackets</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/polos/148`} data-section={click_section} data-link="Polo Shirts">Polo Shirts</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/business-apparel/147`} data-section={click_section} data-link="Business Apparel">Business Apparel</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/workwear-uniforms/149`} data-section={click_section} data-link="Workwear & Uniforms">Workwear & Uniforms</a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-column">
          <ul class="ciProducts-column-list">
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/activewear/44`} data-section={click_section} data-link="Activewear">Activewear</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/team-jerseys/425`} data-section={click_section} data-link="Team Jerseys">Team Jerseys</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/pants-shorts/178`} data-section={click_section} data-link="Pants & Shorts">Pants & Shorts</a>
            </li>
            <li>
            <a href={`${process.env.CI_HOSTNAME}/products/accessories/574`} data-section={click_section} data-link="Accessories">Accessories</a>
            </li>
          </ul>
        </div>
        <div class="ciProducts-image ciProducts-image--apparel">
        </div>
      </div>
    );
  }
}
